// extracted by mini-css-extract-plugin
export default {"menuDiv":"MenuItems_menuDiv__5TPF2","open":"MenuItems_open__+cjlX","ul":"MenuItems_ul__KRsRB","homeLi":"MenuItems_homeLi__uxZNl"};